import React, { useState, useEffect } from "react";
import moment from "moment/moment";
import axiosInstance from "../../../../axios";
import "./webinar.css";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Loading } from "../../../Other/Loading";
import { AuthorizedWrapper } from "../../../Other/AuthorizedWrapper";
import { getS3URL } from "../../../../_helpers";

import { useSelector } from 'react-redux';
const WebinarEvents = () => {
  const now = new Date();
  const firstDay = moment(
    new Date(now.getFullYear(), now.getMonth(), 1)
  ).format("YYYY MM,DD");
  const lastDay = moment(
    new Date(now.getFullYear(), now.getMonth() + 1, 0)
  ).format("YYYY MM,DD");

  const history = useHistory();

  const [data, SetData] = useState([]);
  const [startRequest, setStartRequest] = useState();
  const [fetchResponse, setFetchResponse] = useState(false);
  const [webinarStatus, setWebinarStatus] = useState(null);
  const [statusPopUp, setStatusPop] = useState(false);

  const { user } = useSelector((state) => state.users);

  useEffect(() => {
    setFetchResponse(true);
    axiosInstance
      .get(`webinar/all?startDate=${firstDay}&endDate=${lastDay}`)
      .then((response) => {
        setFetchResponse(false);
        SetData(response.data.data);
      })
      .catch((err) => console.log(err));
  }, []);

  const webinarCreationProcess = (id, index) => {
    setStartRequest(index);
    axiosInstance
      .get(`webinar/join?webinarId=${id}`)
      .then(({ data: { data, message } }) => {
        setStartRequest(null);
        if (data) {
          window.location.href = data;
        } else {
          setStatusPop(true)
          setWebinarStatus(message);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleWebinar = () => {
    history.push("/dashboard/CourseBuilder");
  };

  return (
    <>
      <section className="container-wrapper">
        {user.role == 2 ? (
          ""
        ) : (
          <div className="create-course-btn-webinar" onClick={handleWebinar}>
            Add Webinar
          </div>
        )}
        {fetchResponse && <Loading />}
        {data ? data.length == 0 ? (
          <>
            {!fetchResponse && (
              <div class="event-card">
                <span className="recordNotFound">No Events Founds</span>
              </div>
            )}
          </>
        ) : (
          data && data.map((events, index) => (
            <div className="main studentPurchase" key={index}>
              <div className="img-container">
                <img
                  src={getS3URL(events.imageFiles[0].fileName)}
                  className="img"
                  alt="courseImage"
                />
              </div>

              <div className="content">
                <div className="content-inner">
                  <div className="inner-top">
                    <div className="inner-top-flex">
                      <div className="right studentname webinarDetails">
                        Event Name: {events.eventName}
                      </div>
                      {events.status === 1 && <div class="circle"></div>}
                    </div>
                    <div className="inner-top-flex">
                      <div className="right studentname webinarDetails">
                        Course Name: {events.CourseName}
                      </div>
                    </div>
                    <div className="inner-top-flex">
                      <p className="courseNameResponsive webinarDetails">
                        Webinar Date :{" "}
                        {moment(events.webinarDate).format("DD-MM-YYYY")}
                      </p>
                    </div>

                    <div className="inner-top-flex">
                      <p className="courseNameResponsiveAgain webinarDetails">
                        Start Time: {events.startTime}
                      </p>
                    </div>
                    <div className="inner-top-flex">
                      <p className="courseNameResponsiveAgain webinarDetails">
                        End Time: {events.endTime}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="list-btn-div">
                  <div className="view-section">
                    <Link
                      className="btn-edit-content quickview webinarStart-1"
                      to={{
                        pathname: `/dashboard/categories/${events.courseId}`,
                      }}
                    >
                      QUICK VIEW
                    </Link>
                  </div>
                  <div className="view-section">
                    {startRequest !== index && (
                      <button
                        className="btn webinarStart"
                        onClick={() => webinarCreationProcess(events.id, index)}
                      >
                        <span className="display-flex-09">
                          <AuthorizedWrapper authorizedRoles={["Instructor", "Admin"]}>
                            <div>START</div>
                          </AuthorizedWrapper>

                          <AuthorizedWrapper authorizedRoles={["Student"]}>
                            <div>Join</div>
                          </AuthorizedWrapper>
                          <i className="icon icon-video webiner-now-0" />
                        </span>
                      </button>
                    )}
                    {startRequest === index && (
                      <div className="loading-webinar-event">
                        <Loading></Loading>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : data == undefined ? !fetchResponse && (
          <div class="event-card">
            <span className="recordNotFound">No Events Founds</span>
          </div>
        ) : null}

        {statusPopUp && (
          <div className="webinar-joining-alert">
            <div className="custom-popup">
              <div className="custom-popup-inner">
                <div className="EventDeletePreview">
                  <div onClick={() => setStatusPop(false)}>
                    <i className="icon check"></i>
                  </div>
                </div>
                <div className="deleteEventtext">
                  <h1>{webinarStatus}</h1>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};
export default WebinarEvents;
